import { render, staticRenderFns } from "./ResumeProduct.vue?vue&type=template&id=235443d0&"
import script from "./ResumeProduct.vue?vue&type=script&lang=js&"
export * from "./ResumeProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports